import {
LuDatabase,
LuShieldCheck,
LuGithub,
LuInfo,
LuCloud
} from "react-icons/lu"
import { useState,useEffect } from "react"
import { useLocation } from "react-router-dom"
import "./Database.css"

function Database(){

const [loaded,setLoaded]=useState(false)
const [imageLoaded,setImageLoaded]=useState(false)

const location = useLocation()

useEffect(()=>{

// Ensure page always starts from top
window.scrollTo({ top: 0, left: 0, behavior: 'instant' })

setLoaded(false)

const timer=setTimeout(()=>{
setLoaded(true)
},100)

return()=>clearTimeout(timer)

},[location.pathname])

return(

<section className={`database ${loaded?"loaded":""}`}>

<div className="database-left">

<h1>
Database & <span>Storage</span>
</h1>

<div className="database-dotted">
<p>
SLUZ uses modern cloud infrastructure to securely store and manage platform data. User accounts and application data are stored in Firebase Firestore, while blog and feed content is hosted using a public GitHub repository.
</p>
</div>

<div className="database-cards">

<div className="database-card">
<LuDatabase className="database-icon green"/>
<h3>Firestore Database</h3>
<p>User accounts, activity data and platform information are securely stored using Firebase Firestore.</p>
</div>

<div className="database-card">
<LuCloud className="database-icon blue"/>
<h3>Cloud Infrastructure</h3>
<p>Firebase provides a scalable cloud backend allowing real-time data synchronization and reliable performance.</p>
</div>

<div className="database-card">
<LuGithub className="database-icon orange"/>
<h3>Blog Storage</h3>
<p>Blog content and public resources are hosted through a GitHub repository to keep all resources transparent.</p>
</div>

<div className="database-card">
<LuShieldCheck className="database-icon purple"/>
<h3>Open Source Resources</h3>
<p>Most content used on the platform comes from publicly available learning resources and documentation.</p>
</div>

</div>

<div className="database-buttons">

<button
className="primary-btn"
onClick={()=>window.open("https://github.com/sanketpadhyal/sluz-feed.git","_blank")}
>
<LuGithub className="btn-icon"/> Storage Repository
</button>

<button
className="secondary-btn gold-btn"
onClick={()=>window.open("https://firebase.google.com/docs/firestore","_blank")}
>
<LuInfo className="btn-icon"/> Learn More
</button>

</div>

</div>

<div className="database-right">

<div className="database-image-wrapper">

{!imageLoaded && <div className="database-skeleton"></div>}

<img
src="/assets/database.png"
alt="database architecture"
className={`database-image ${imageLoaded?"show":"hide"}`}
onLoad={()=>setImageLoaded(true)}
draggable="false"
/>

</div>

</div>

</section>

)

}

export default Database